// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__L0VrD","selects":"Documents_selects__3QpUf"};